import { each, mapObject } from "zeta-dom/util";
import waterpipe from "waterpipe";
import config from "src/config";
import { AIA_ENV } from "src/config/env";
import { AnalyticEventName } from "src/config/types";

function transformObject(obj: Zeta.Dictionary, context?: Zeta.Dictionary): Zeta.Dictionary {
    return mapObject(obj, (v: any) => {
        switch (typeof v) {
            case 'string':
                return waterpipe(v, context);
            case 'object':
                return transformObject(v, context);
        }
        return v;
    });
}

export function sendAnalytic(event: AnalyticEventName, context?: Zeta.Dictionary) {
    each(config.analyticConfig[event], function (_, v) {
        const data = context ? transformObject(v, context) : v;
        if (AIA_ENV) {
            ((window as any).adobeDataLayer || ((window as any).adobeDataLayer = [])).push(data);
        } else {
            console.log('[Analytic]', data);
        }
    });
}

if (AIA_ENV) {
    const script = document.createElement('script');
    script.defer = true;
    script.src = AIA_ENV === 'prd' ?
        'https://assets.adobedtm.com/e17df9099c11/dc66235de47d/launch-a0578237aad4.min.js' :
        'https://assets.adobedtm.com/e17df9099c11/dc66235de47d/launch-e212548b3724-staging.min.js';
    document.head.appendChild(script);
}
